import { emailRegex } from '@net0-calc/common/constants/regex';

export const isEmail = (value: string) => emailRegex.test(value);
